// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fix the alignment and spacing for multiple buttons */
.contact__container {
    display: flex !important;
    justify-content: center;
    align-items: center;
    gap: 2rem; /* Spacing between the circles */
    margin-top: 2rem;
}

/* Force both the mail and phone links to use your theme's large button styles */
.contact__container > a {
    aspect-ratio: 1/1 !important;
    background: var(--color-primary) !important;
    border: 2px solid transparent !important;
    border-radius: var(--border-radius-1) !important;
    color: var(--color-white) !important;
    display: grid !important;
    place-items: center !important;
    width: 5rem !important; /* Forces the box back to the large size */
    height: 5rem !important;
    transition: var(--transition) !important;
    text-decoration: none !important;
}

/* Target the React Icons inside the buttons to make them large */
.contact__container > a svg {
    width: 2.5rem !important;
    height: 2.5rem !important;
    fill: currentColor !important;
}

/* Apply your theme's clean hover effect to both buttons */
.contact__container > a:hover {
    background: transparent !important;
    border-color: var(--color-primary) !important;
    color: var(--color-primary) !important;
    transform: translateY(-5px) !important;
}

@media screen and(max-width: 600px) {
  .contact__container {
    gap: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/contact/contact.css"],"names":[],"mappings":"AAAA,uDAAuD;AACvD;IACI,wBAAwB;IACxB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS,EAAE,gCAAgC;IAC3C,gBAAgB;AACpB;;AAEA,gFAAgF;AAChF;IACI,4BAA4B;IAC5B,2CAA2C;IAC3C,wCAAwC;IACxC,gDAAgD;IAChD,oCAAoC;IACpC,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB,EAAE,0CAA0C;IAClE,uBAAuB;IACvB,wCAAwC;IACxC,gCAAgC;AACpC;;AAEA,iEAAiE;AACjE;IACI,wBAAwB;IACxB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA,0DAA0D;AAC1D;IACI,kCAAkC;IAClC,6CAA6C;IAC7C,sCAAsC;IACtC,sCAAsC;AAC1C;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":["/* Fix the alignment and spacing for multiple buttons */\n.contact__container {\n    display: flex !important;\n    justify-content: center;\n    align-items: center;\n    gap: 2rem; /* Spacing between the circles */\n    margin-top: 2rem;\n}\n\n/* Force both the mail and phone links to use your theme's large button styles */\n.contact__container > a {\n    aspect-ratio: 1/1 !important;\n    background: var(--color-primary) !important;\n    border: 2px solid transparent !important;\n    border-radius: var(--border-radius-1) !important;\n    color: var(--color-white) !important;\n    display: grid !important;\n    place-items: center !important;\n    width: 5rem !important; /* Forces the box back to the large size */\n    height: 5rem !important;\n    transition: var(--transition) !important;\n    text-decoration: none !important;\n}\n\n/* Target the React Icons inside the buttons to make them large */\n.contact__container > a svg {\n    width: 2.5rem !important;\n    height: 2.5rem !important;\n    fill: currentColor !important;\n}\n\n/* Apply your theme's clean hover effect to both buttons */\n.contact__container > a:hover {\n    background: transparent !important;\n    border-color: var(--color-primary) !important;\n    color: var(--color-primary) !important;\n    transform: translateY(-5px) !important;\n}\n\n@media screen and(max-width: 600px) {\n  .contact__container {\n    gap: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
